<template>
  <div>
    <div class="common-header-wrap">
      <mt-header title="代收点加盟" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div>
    <div>
      <div class="label">账户登录信息</div>
      <mt-field label="用户名" v-model="chain.chain_name"></mt-field>
      <mt-field label="密码" type="password" v-model="chain.password"></mt-field>
      <mt-field label="确认密码" type="password" v-model="chain.confirm_password"></mt-field>
      <div class="label">申请人认证</div>
      <mt-field label="真实姓名" v-model="chain.chain_truename"></mt-field>
      <mt-field label="身份证号码" v-model="chain.chain_idcard"></mt-field>
      <mt-cell class="pt-5" title="身份证照片">
        <div class="user-avatar-wrapper">
          <div v-if="chain.chain_idcardimage" class="user-avatar">
            <img :src="chain.chain_idcardimage_url" @click="openImage(chain.chain_idcardimage_url)">
            <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
          </div>
          <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('chain_idcardimage',$event)">
            <div class="center-text">相机/相册</div>
            <input type="file" accept="image/*">
          </div>
        </div>
      </mt-cell>
      <div class="label">代收点信息提交</div>
      <mt-field label="代收点名称" v-model="chain.chain_addressname"></mt-field>
      <div @click="onRegion()"><mt-cell title="所在地" is-link>{{chain.chain_area_info}}</mt-cell></div>
      <div @click="popMap=true"><mt-cell title="详细地址" is-link>{{chain.chain_address}}</mt-cell></div>
      <mt-field label="联系手机" v-model="chain.chain_mobile"></mt-field>
      <mt-field label="固定电话" v-model="chain.chain_telephony"></mt-field>

      <mt-button size="large" type="primary" @click="submit" class="ds-button-large mt-10">提交</mt-button>
    </div>
</div>
    <div>
      <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
        <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
      </mt-popup>
    </div>
    <div>
      <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
    </div>
    <div>
      <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="定位" class="common-header">
            <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <map-select ref="map_select" :longitude="chain.chain_longitude" :latitude="chain.chain_latitude" @setPosition="setPosition"></map-select>
        </div>
      </mt-popup>
    </div>
    <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="裁剪图片" class="common-header">
          <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
          <mt-button slot="right" @click="useCrop">使用</mt-button>
        </mt-header>
      </div>
      <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
    </mt-popup>
  </div>
</template>
<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import RegionPicker from '../../RegionPicker'
import MapSelect from '../../MapSelect'
import { uploadInfoFile, chainApply } from '../../../api/chainLogin'
import { chainInformation, chainApplyAgain } from '../../../api/chainManage'
import { getPointByAddress } from '../../../util/bmap'
export default {
  components: {
    RegionPicker,
    MapSelect,
    VueCropper
  },
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      showimage: '',
      isshow: false,
      popMap: false,
      chain: {},
      verifyState: 0
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      user: state => state.chain.info
    }),
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }
  },
  created: function () {
    if (this.user) {
      chainInformation().then(res => {
        let info = res.result.chain_info
        this.chain = info
        if (info.chain_state == 1) {
          Toast('代收点已开通')
          this.$router.push({ name: 'ChainLogin' })
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'
    }),
    submit () {
      if (this.chain.chain_id) {
        chainApplyAgain(this.chain).then(res => {
          Toast(res.message)
          this.$router.push({ name: 'ChainLogin' })
        }).catch(error => {
          Toast(error.message)
        })
      } else {
        chainApply(this.chain).then(res => {
          Toast(res.message)
          this.$router.push({ name: 'ChainLogin' })
        }).catch(error => {
          Toast(error.message)
        })
      }
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.chain.chain_address = name
      this.chain.chain_longitude = lng
      this.chain.chain_latitude = lat
      this.$forceUpdate()
    },
    onPickerConfirm (values) {
      this.chain.chain_area_info = this.getRegionStr(values)
      this.chain.chain_area_2 = values[1] ? values[1].area_id : 0
      this.chain.chain_area_3 = values[2] ? values[2].area_id : 0
      this.selectCity(values.length > 1 ? values[1].area_name : values[0].area_name)
      this.$forceUpdate()
    },
    onRegion () {
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage () {
      this.chain.chain_idcardimage = ''
      this.$forceUpdate()
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        formdata.append('name', 'file')

        uploadInfoFile(formdata).then(res => {
          this.chain.chain_idcardimage = res.result.path
          this.chain.chain_idcardimage_url = res.result.url
          this.showCrop=false
          this.$forceUpdate()
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    selectCity (city_name) {
      getPointByAddress(city_name).then(res => {
        if (res.result.location) {
          var lng = res.result.location.lng
          var lat = res.result.location.lat
          this.chain.chain_latitude = lat
          this.chain.chain_longitude = lng

          this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.formatted_address, cityCode: res.result.cityCode, cityName: city_name } })
          // this.$forceUpdate()
        } else {
          Toast('无法获取城市位置')
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
  .container {
    background: #fff;
  }
  .label {
    padding: .5rem;
    font-size: .7rem;
    background: #eee;
  }
  .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
  .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
  .user-avatar {
    display: block;
    border:1px solid #eee;
    position: relative;
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    text-align: center;
    img {
      width: 100%;
      height: 100%
    }
    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0
    }
    .center-text{padding:.2rem;padding-top:3.5rem;font-size:.6rem}
  }
  .user-avatar::before {
    position: absolute;
    font-size: 1.5rem;
    line-height: 5rem;
    left: 50%;
    margin-left: -.75rem;
    color: rgba(0, 0, 0, 0.5)
  }

</style>
